
import {
  SET_METRICS_DEFINITIONS,
} from '../constants';

const initialFieldsState = {
  fetched: false,
  items: [],
};

const metricsDefinitions = (state = initialFieldsState, action) => {
  switch (action.type) {
    case SET_METRICS_DEFINITIONS:
      return {
        fetched: true,
        items: action.payload,
      };
    default:
      return state;
  }
};

export default metricsDefinitions;
